export function Footer() {
  return `
    <footer class="footer">
      <div class="footer__content">
        <div class="footer__address text-lg font-medium">
          <p>Via Gioia del Colle 40 BA<br>70017 Putignano, Italy</p>
        </div>
        <div class="footer__opening-hours">
          <p class="footer__opening-hours-title text-sm font-medium">ORARI DI APERTURA</p>
          <p class="footer__opening-hours-desc text-base">Dal Lunedì al Venerdì: 7:00 - 21:00<br>Sabato: 8:00 - 13:00</p>
        </div>
        <div class="footer__contacts">
          <p class="footer__contacts-title text-sm font-medium">CONTATTI</p>
          <p class="footer__contacts-desc text-base">Scrivici una mail a <a href="mailto:info@formastudiotraining.com">info@formastudiotraining.com</a><br>Instagram <a href="https://www.instagram.com/formastudio.training">@formastudio.training</a></p>
        </div>
        <div class="footer__cta">
          <a href="https://calendar.app.google/1JjTCQx96w6tuZjq9" class="btn__primary" target="_blank">Prenota una consulenza</a>
        </div>
      </div>
      <div class="footer__brand">
        <img src="/images/footer-logo.png" alt="Forma Studio Logo">
      </div>
      <div class="footer__copyright text-xs">&copy; 2025 Forma Studio Srls - Via Gioia del Colle, 40 - 70017 Putignano (BA) | P.Iva: 08888740720 | <a href="#/privacy-policy">Privacy e Cookie Policy</a></div>
    </footer>
  `;
} 